export const IS_EMPTY_FEATURE = 'IS_EMPTY_FEATURE';
export const isEmptyFeature = (editorState, raw)=>{
    return {
        type: IS_EMPTY_FEATURE,
        data: {
            isEmpty: !(editorState.getCurrentContent().getPlainText().trim() || Object.keys(raw.entityMap).length)
        }
    };
};
